import { DeleteOutlineIcon } from './DeleteOutlineIcon';

/**
 * author: Google
 * id 59ADF7EF-9F3E-4957-A789-95788D13B9E4
 * name delete-outline
 * version: 2.5.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/delete-outline.svg
 * tags
 */
export const GarbageCanOutlineIcon = DeleteOutlineIcon;
export default GarbageCanOutlineIcon